import * as PropTypes from 'prop-types';
import * as React from 'react';
import Tooltip from '../../tooltip';
import * as classNames from 'classnames';
import OperatingSystemIcons from '../operating_system_icons';
import PriceDisplay from '../../shared/price_display';
import { Link } from 'react-router';
import { MobileDetection } from '@reverbdotcom/discovery-ui';

const IMAGE_SIZE_MOBILE = 265;
const IMAGE_SIZE_DESKTOP = 131;
const OPERATING_SYSTEM_ORDER = [
  'dfeffbaa-53a1-41e6-b8cf-e145b8dcd772',
  '0504f1bc-5727-4c11-943b-21ae32d664fb',
  '45d3ae2e-ddfe-411b-9119-ac4a0f8ac823',
];

class ListingCardWide extends React.Component {
  imageSize() {
    return MobileDetection.isMobileBrowser() ? IMAGE_SIZE_MOBILE : IMAGE_SIZE_DESKTOP;
  }

  get listingUrl() {
    return new URL(this.props.listing._links.web.href).pathname;
  }

  sortedOperatingSystems() {
    return this.props.listing.operating_systems.sort((first, second) => {
      const firstIndex = OPERATING_SYSTEM_ORDER.indexOf(first.value_uuid);
      const secondIndex = OPERATING_SYSTEM_ORDER.indexOf(second.value_uuid);
      return firstIndex - secondIndex;
    });
  }

  renderOperatingSystems() {
    return this.sortedOperatingSystems().map(operatingSystem =>
      (<Tooltip title={operatingSystem.value_name} key={operatingSystem.value_uuid}>
        <i
          className={
            classNames(
              'fa',
              'ml-half',
              'mr-half',
              `fa-${OperatingSystemIcons[operatingSystem.value_uuid]}`,
            )
          }
        />
       </Tooltip>));
  }

  renderPriceDropBanner() {
    if (this.props.listing.price_drop) {
      return (
        <p className="ribbon-view ribbon-view--pricedrop">
          {this.props.listing.price_drop.display}
        </p>
      );
    }

    return null;
  }

  render() {
    return (
      <li className="digital-product-card">
        <Link className="digital-product-card__link" to={this.listingUrl}>
          {this.renderPriceDropBanner()}
          <div className="digital-product-card__image">
            <img
              className="img-wide img-hoverable"
              width={this.imageSize()}
              height={this.imageSize()}
              alt={this.props.listing.name}
              src={this.props.listing._links.primary_photo.href}
            />
          </div>
          <div className="digital-product-card__body">
            <h3 className="digital-product-card__body-title">{this.props.listing.name}</h3>
            <p className="digital-product-card__body-brand">
              {I18n.t('digitalListingCard.by')} {this.props.listing.brand}
            </p>
            <div className="digital-product-card__body-divider" />
            <p className="digital-product-card__body-summary">
              {this.props.listing.oneline_summary}
            </p>
          </div>
          <div className="digital-product-card__actions">
            <div className="digital-product-card__price">
              <PriceDisplay
                price={this.props.listing.price}
                showFree
              />
            </div>

            <div
              className="digital-product-card__view-details"
              href={this.props.listing._links.web.href}
            >
              {I18n.t('digitalListingCard.callToAction')}
            </div>

            <div className="digital-product-card__operating-systems">
              {this.renderOperatingSystems()}
            </div>
          </div>
        </Link>
      </li>
    );
  }
}

ListingCardWide.propTypes = {
  listing: PropTypes.object.isRequired,
};

export default ListingCardWide;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/listing_card_wide.jsx